<div
  class="dashboard-chart-empty-state"
  role="status"
  [style.min-height]="minHeight()">
  <div class="dashboard-chart-empty-state__info">
    <mat-icon aria-hidden="true">info</mat-icon>
    <span>{{ messageKey() | translate }}</span>
  </div>
</div>
